import $ from 'jquery';

/* Limit the filter content height
* on mobile screen
*
* jQuery function
*/
function $setFilterContentHeight() {
  const mqString = '(max-width: 1140px)',
    $target = $('.widget.unit-filter .overflow-scroll');

  if (!window.matchMedia(mqString).matches && $target.css('max-height') === 'none') {
    return;

  } else if (!window.matchMedia(mqString).matches && $target.css('max-height') !== 'none') {
    $target.css('max-height', '');
    return;
  }

  let pxToFloat = (px) => {
      if (!px) {
        return '';
      }
      return parseFloat(px.replace('px', ''));
    },
    getDomHeight = ($dom) => {
      let outerHeight = $dom.outerHeight(),
        marginTop = pxToFloat($dom.css('margin-top')),
        marginBottom = pxToFloat($dom.css('margin-bottom'));

      return outerHeight + marginTop + marginBottom;
    },
    // heights
    deviceHeight = document.documentElement.clientHeight || 0,
    widgetPaddings = pxToFloat( $('.widget.unit-filter').css('padding-top') ) +
      pxToFloat( $('.widget.unit-filter').css('padding-bottom') ),
    inputHeight = getDomHeight( $('#query-degree-name') ),
    btnRowHeight = getDomHeight( $('.widget.unit-filter .sq-form-control') ),
    // result height
    resultHeight = deviceHeight - widgetPaddings - inputHeight - btnRowHeight;

  $target.css('max-height', resultHeight);
}

/* make page list container height equals filter container height + contact widget height
 *
 */
function $setEqualHeight() {
  let mqString = '(max-width: 1140px)',
    $leftNav = $('.app-sub-nav-wrapper'),
    $rightNav = $('.sidebar'),
    $main = $('.application .main-content'),

    leftNavHeight = $leftNav.length > 0 ? $leftNav.outerHeight() : 0,
    rightNavHeight = $rightNav.length > 0 ? $rightNav.outerHeight() : 0;

  if (!window.matchMedia(mqString).matches) {
    $main.css('min-height', leftNavHeight + rightNavHeight);
  } else {
    $main.css('min-height', '');
  }
}

/* Ajax Call
 *
 * jQuery function
 */
function $fetchData(url, data, callback) {
  $.ajax({
    url:     url,
    type:    'GET',
    data:    data,
    cache:   true,
    success: (result) => {

      if (typeof callback !== 'function') {
        return;
      }
      callback.apply(null, [result]);
    }
  });
}


 /* bind click event to button element
* to scroll to the target element
*
* jQuery function
*/
function $scrollTo($btn, $target) {
  $btn.on('click', (e) => {
    e.preventDefault();

    let target = $target[0],
        bodyScrollTop = $('body').scrollTop(),
        offsetTop = 0;

    if ($target.length === 0) {
      return;
    }

    //scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    offsetTop = target.getBoundingClientRect().top;

    $('html,body').animate(
      {scrollTop: offsetTop + bodyScrollTop}, 500);
  });
}

/* change dom's z-index
* @param [jquery object] $dom
*        [number] zIndex
*/
function $changeZIndex($dom, zIndex) {
  $dom.css('z-index', zIndex);
}

export {
  $setFilterContentHeight,
  $setEqualHeight,
  $fetchData,
  $scrollTo,
  $changeZIndex
};
